
export const breadUrlMapMixin={

    computed:{
        breadcrumbUrlWordMap(){
            return{
            '/user/login':'',         
            '/study/center': this.$t("study.studycenter"),
            '/study/schedule': this.$t("schedule.courseSchedule"),
            '/study/salonInfo': this.$t("study.salonDetail"),
            '/study/bookLessonSelect': this.$t("book.selectTheme"),
            '/study/bookSmallClassSelect': this.$t("book.selectTheme"),
            '/study/bookLessonInfo': this.$t("book.themeDetail"),
            '/study/bookSmallClassInfo': this.$t("book.themeDetail"),
            '/study/bookTimeSelect': this.$t("book.reserveLessonTime"),
            '/study/timeTableSelect': this.$t("book.reserveLessonTime"),
            '/study/bookConfirm': this.$t("book.bookDetail"),            
            '/neo/neoBox': this.$t("schedule.neoPlacementTest"),
            '/study/bookPreferredTime':'优选时间',
            '/RTbooking/editbookSelect':'选择时间',
            '/RTbooking/lessonPage': this.$t("schedule.ksxq"),
        
            '/course/courseware': this.$t("course.viewCourseware"),
        
            '/eval/evalTeaching': this.$t("eval.evalTeacher"),
            '/eval/teacherOverallEval': this.$t("eval.teaEvaluation"),
        
            '/my/endedCourse': this.$t("my.endCourse"),
            '/my/notice': this.$t("my.myMsg"),
            '/my/noticeDetail': this.$t("msg.msgDetail"),
            '/my/outerChain': this.$t("msg.noticeIframe"),
        
            '/survey/survey-answer/': this.$t("eval.teaEvaluation"),
            '/survey/questionnaireAnswer/': this.$t("eval.evalType5"),
            '/eval/variousEval': '其他评价',
        
            '/follow/list': this.$t("follow.followListTit"),
            '/follow/feedback': this.$t("follow.feedBack"),

            '/my/myJoin':this.$t('myJoin.myJoin'),

            '/certificate/myCertificate': this.$t("certificate.myCertificate"),
            '/certificate/certificateLevel': this.$t("certificate.certificateLevel"),
          }
        }
     
    }

}


// WEBPACK FOOTER //
// ./src/mixins/breadUrlMap.js